import React from 'react';
import { Calendar, AlertCircle } from 'lucide-react';

interface DatePickerProps {
  label: string;
  className?: string;
  value: string;
  minDate?: string;
  required?: boolean;
  error?: string;
  onChange: (date: Date | null) => void;
}

const DatePicker: React.FC<DatePickerProps> = ({
  label,
  className,
  value,
  minDate,
  required = false,
  error,
  onChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      onChange(null);
      return;
    }
    const selectedDate = new Date(e.target.value);
    onChange(selectedDate);
  };

  return (
    <>
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium text-neutral-light">{label}</label>
        {required ? (
          <span className="text-xs text-accent">Required</span>
        ) : (
          <span className="text-xs text-text-muted">Optional</span>
        )}
      </div>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <Calendar className="h-5 w-5 text-text-muted" />
        </div>
        <input
          type="date"
          value={value || ''}
          min={minDate ? minDate : undefined}
          onChange={handleChange}
          className={className}
          required={required}
        />
      </div>
      {error && (
        <div className="flex items-center gap-2 mt-1.5">
          <AlertCircle className="w-4 h-4 text-rose-400" />
          <span className="text-xs text-rose-400">{error}</span>
        </div>
      )}
    </>
  );
};

export default DatePicker;
